<template lang="pug">
div
  .gt-sm
    .row.full-width.mozaika-bg.justify-start
      .column.col.col-6.col-lt-md-12.offset-1.justify-center.landing-col.q-px-md
        .row.justify-start.q-mb-xl
          q-avatar.col-2.collection-logo
            img.collection-logo(src="statics/icons/animated-logo.gif")
          q-space
          q-btn.col-2(size="md" flat color="grey-8" stack label="Nový předmět"
                icon="add_box" :to="{ name: 'collection-create', params: {collectionCode: 'restorations' }}")
          q-btn.col-2(size="md" flat color="grey-8" stack label="Administrace"
                icon="settings" :to="{ name: 'administration' }")
        .row.justify-start.q-mt-lg.q-pr-lg
          .text-h3.text-left.strong.repo-name.one-word-per-line(v-t="'layout.application.title'")
          q-separator.full-width.q-my-md(inset)
          span.text-h4.text-left.repo-subtitle(v-t="'layout.application.subtitle'")
        .row.justify-start.q-gutter-md.q-mt-lg
          q-input.search.full-width(rounded standout v-model="search" @keyup.enter="enteredSearch"
                                    label="Vyhledat předmět…")
            template(v-slot:append)
              q-btn(icon="search" round flat v-if="(search !== '' && search.length > 3)" @click="enteredSearch")
        .row.justify-start.q-my-md
          q-btn(size="lg" flat color="primary" icon-right="arrow_forward"
                label="Procházet předměty"
                :to="{ name: 'collection', params: {collectionCode: 'restorations' }}")
        .q-footer.fixed-bottom.q-pa-lg
          .text-info.text-right.text-white.text-italic Version: {{ $store.getters.appVersion }}
      .col.col-5.justify-end.mozaika.landing-col
        img.float-right(src="statics/Mozaika-crop.png")
  .lt-md
    div.row.justify-center
      img.logo(src="/statics/icons/logo.png")
    div.row.justify-center
      h5.text-center.repo-name(v-t="'layout.application.title'")
      q-separator.full-width.q-my-md(inset)
      span.text-h6.text-left.repo-subtitle(v-t="'layout.application.subtitle'")
    .red-block.q-py-xl
      .row.justify-center
        table.collection-refs
          tr
            td.collection-ref(align="center")
              q-btn.fit(flat='', color='primary', :to="{ name: 'collection', params: {collectionCode: 'restorations' }}")
                q-icon.collection-logo(name="fab fa-artstation" color="white")
            td.collection-ref(align="center")
              q-btn.fit(flat='', color='primary', :to="{ name: 'administration' }")
                q-icon.collection-logo(name="settings" color="white")
          tr.q-pb-lg
            td
              q-btn(flat='', color='primary', :to="{ name: 'collection', params: {collectionCode: 'restorations' }}")
                span.collection-link Restaurované předměty
            td
              q-btn(flat='', color='primary', :to="{ name: 'administration' }")
                span.collection-link Správa systému
    .q-footer.fixed-bottom.q-pa-lg
      .text-info.text-grey-9 Version: {{ $store.getters.appVersion }}
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { Query } from '@oarepo/invenio-oarepo-ui-vue'

export default @Component({
  name: 'oarepo-collection-list-page'
})
class AllCollectionsPage extends Vue {
  search = ''

  get searchUrl () {

  }
  enteredSearch () {
    if (this.search.length <= 3) { return }
    const q = new Query(this.$route.query)
    q.replace('q', this.search)
    this.$router.push({
      name: 'collection',
      params: { collectionCode: 'restorations' },
      query: q.query
    })
  }
  get locale () {
    return this.$i18n.locale
  }
}
</script>

<style lang="stylus" scoped>
.top-indent
  margin-top: 100px

img.logo
  max-width 640px
  max-height 250px
.landing-col
  height 100vh

.collection-logo
  width fit-content !important
  height fit-content !important
  font-size 42px
  text-align center

.repo-name
  color #918e81
  font-weight: 400

.repo-subtitle
  color #918e81
  font-weight: 200
  padding-bottom 20px

.xs
  img.logo
    width 32px
    height 32px

.search
  max-width 400px
  >>> .q-field__control
    padding-left 20px

.red-block
  min-height 100px
  background-color #ffffff
  background linear-gradient(to bottom, #f03c1fff 0%, #f03c1fff 70%, #ffffff 70.1%, #ffffff 100%)

.collection-list
  background-color transparent

.collection-ref
  img
    height 20vh

.collection-link
  white-space pre
  line-height 1.2em
  color white !important
  font-weight 600

.collection-link-container
  border-right: 1px solid gray

.collection-link-container-left
  border-left: 1px solid gray

.collection-refs
  td
    padding-left 1em
    padding-right 1em

.one-word-per-line {
    word-spacing: 800px;
}

.mozaika
  overflow hidden

  img
    height 100%

.mozaika-bg
  background: transparent linear-gradient(289deg, #E4A371 0%, #c2c2c2 41%, #c7c7c7 54%, #FFFFFF 100%) 0% 0% no-repeat padding-box;
  opacity: 1;

</style>
